import { routes } from "@/routing/routes";
import buybackRoutesWeb from "@/apps/whiteLabelWebsite/buyback/routing/routes";

export default [
  {
    path: buybackRoutesWeb.proposalAcceptCounter.path,
    name: buybackRoutesWeb.proposalAcceptCounter.name,
    component: () => import("@/apps/whiteLabelWebsite/buyback/view/pages/Litigation/ProposalCounter.vue"),
  },
  {
    path: buybackRoutesWeb.proposalRejectCounter.path,
    name: buybackRoutesWeb.proposalRejectCounter.name,
    component: () => import("@/apps/whiteLabelWebsite/buyback/view/pages/Litigation/ProposalCounter.vue"),
  },
  {
    path: routes.cartCheckout.path,
    name: routes.cartCheckout.name,
    component: () =>
      import(/* webpackChunkName: "cartCheckout" */ "@/apps/shared/buyback/view/pages/Cart/CartCheckout.vue"),
    props: (route) => ({ cartId: route.params.cartId }),
  },
];
